module.exports = __webpack_public_path__ + "d16d6bb3eca5f7d976e5c45fccb60dee.svg";